module.exports = __webpack_public_path__ + "static/media/site-robertarachid-ecommerce.832568d0.jpg";